import styled from "styled-components"

import { minWidth } from "utils"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 5rem 2.7rem 3rem;

  ${minWidth.tablet`
    width: auto;
    max-width: 58rem;
    margin: 5rem auto 3rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
  `}

  ${minWidth.desktop`
    margin: 8rem auto 3rem;
  `}

  ${minWidth.desktopXL`
    max-width: 82.5rem;
  `}
`

export const Category = styled.div`
  width: fit-content;
  margin-bottom: 2.8rem;
  padding: 0.4rem 0.8rem;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  background-color: #003445;
  color: #fff;

  ${minWidth.desktopXL`
    font-size: 1.2rem;
  `}
`

export const Title = styled.h3`
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3.2rem;
  line-height: 4.32rem;
  margin-bottom: 3.2rem;
`

export const ImagesAndSources = styled.div`
  margin-bottom: 0;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;

  ${minWidth.desktop`
    flex-direction: row;
    justify-content: flex-start;
  `}
`

export const Left = styled.div`
  width: 100%;
`

export const Right = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;

  ${minWidth.desktop`
    margin: 0 2rem 2rem 2rem;
  `}

  ${minWidth.desktopXL`
    margin: 4.8rem;
  `}
`

export const OtherDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4.8rem;

  ${minWidth.tablet`
    margin: 0;
  `}

  ${minWidth.desktopXL`
    padding: 3.6rem;
    margin: 0 1.6rem;
  `}
`

export const Hr = styled.div`
  width: 100%;
  height: 0;
  border-bottom: 3px solid #eee;
  margin-bottom: 3rem;
`
